(function () {
    'use strict';

    angular.module('app')
        .factory('CategoriaNovedad', Service);

    /* @ngInject */
    function Service(ResourceHelper) {
        var entidad = "categoria-novedad";
        return ResourceHelper.getResource(entidad, {}, {});
    }

})();
